import React, { useState } from "react";

export const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className={`navbar-toggle ${menuOpen ? "" : "collapsed"}`}
            onClick={toggleMenu}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

          <a className="navbar-brand page-scroll" href="#page-top">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                whiteSpace: "nowrap",
                overflow: "hidden",
              }}
            >
              <img
                src="img/logo.png"
                alt="Logo"
                style={{ height: "40px", marginRight: "6px" }}
              />
              <img
                src="img/logotext.png"
                alt="Logo Text"
                style={{ height: "40px" }}
              />
            </div>
          </a>
        </div>

        <div
          className={`collapse navbar-collapse ${menuOpen ? "in" : ""}`}
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#about" className="page-scroll" onClick={closeMenu}>
                About Us
              </a>
            </li>
            <li>
              <a href="#solutions" className="page-scroll" onClick={closeMenu}>
                What We Make
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll" onClick={closeMenu}>
                How We Help
              </a>
            </li>
            <li>
              <a href="#team" className="page-scroll" onClick={closeMenu}>
                Our Team
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll" onClick={closeMenu}>
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
